export var handleLocationChange = function (controllerParams, onChange) { return function () {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    controllerParams.controllerConfig.wixCodeApi.location.onChange(onChange);
    return Promise.resolve();
}; };
//# sourceMappingURL=handleLocationChange.js.map